import { SafeArea } from '@capacitor-community/safe-area';

export const SafeAreaService = {
    async init() {
        try {
            // Initial read
            const insets = await SafeArea.getSafeAreaInsets();
            this.applyInsets(insets);

            // Listen for changes (e.g. rotation)
            /* SafeArea.addListener('safeAreaChanged', (data) => {
                 this.applyInsets(data.insets);
             });*/
        } catch (e) {
            console.warn('SafeArea plugin not available or failed:', e);
            // Fallback to 0 if needed, though CSS variables default to 0 anyway if not set
            this.applyInsets({ top: 0, bottom: 0, left: 0, right: 0 });
        }
    },

    applyInsets(insets) {
        const root = document.documentElement;
        root.style.setProperty('--safe-area-top', `${insets.top}px`);
        root.style.setProperty('--safe-area-bottom', `${insets.bottom}px`);
        root.style.setProperty('--safe-area-left', `${insets.left}px`);
        root.style.setProperty('--safe-area-right', `${insets.right}px`);

        /* console.log('[SafeAreaService] Applied insets:', insets);*/
    }
};
